if (!customElements.get('site-marquee')) {
  class SiteMarquee extends HTMLElement {
    constructor () {
      super()
      const duration = this.dataset.duration
      const shadowRoot = this.attachShadow({ mode: 'open' })
      shadowRoot.innerHTML = this.getInnerHTML()

      const width = this.querySelector('[slot="content"]').scrollWidth / 5
      shadowRoot.innerHTML = this.getInnerHTML(width, duration)

      setTimeout(() => {
        this.classList.remove('ut-Opacity-0')
        this.classList.remove('ut-Invisible')
      }, 400)
    }

    getInnerHTML (width = 0, duration = '20s') {
      return `
        <style>
          ::slotted([slot="content"]) {
            display: grid;
            grid-auto-flow: column;
            align-items: center;
            height: 100%;
          }
          .marquee-list {
            display: grid;
            grid-auto-flow: column;
            align-items: center;
            white-space: nowrap;
            animation: marquee ${duration} linear infinite;
            height: 100%;
          }
  
          @keyframes marquee {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-${width}px);
            }
          }
        </style>
        <div class="marquee-cont">
          <div class="marquee-list">
            <slot name="content"></slot>
          </div>
        </div>
      `
    }
  }

  customElements.define('site-marquee', SiteMarquee)
}
